import { render } from "./pediatrics_head.vue?vue&type=template&id=e916745c&scoped=true"
import script from "./pediatrics_head.vue?vue&type=script&lang=js"
export * from "./pediatrics_head.vue?vue&type=script&lang=js"

import "./pediatrics_head.vue?vue&type=style&index=0&id=e916745c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e916745c"]])

export default __exports__